module.exports = __webpack_public_path__ + "img/icon-flag-en.b751b213.svg";